import { ValidUrl } from "@payping/utils/validation";
import { Button, Copy, Flex, Form, Modal, Space, Typography, useMessagedAsyncFn } from "@payping/web-components";
import { CheckCircleFilled } from "@payping/icons";
import { OtpCode } from "@/components/OtpCode";
import { useState } from "react";
import { clientApis } from "@payping/api";
import { useAppTranslation } from "@/utils";
import { pluginsListList } from "./data";

interface ModalProps {
  visible?: boolean;
  onClose: () => void;
  pluginKey: string;
}
const GetTokenModal = (props: ModalProps) => {
  const { t } = useAppTranslation();
  const [form] = Form.useForm<any>();
  const [isOtpValid, setIsOtpValid] = useState(false);

  const [{ loading, value: createdToken }, handleCreate] = useMessagedAsyncFn(async (values) => {
    const { serviceType } = pluginsListList[props.pluginKey];
    if (serviceType) {
      const value = await clientApis.createAccessTokenWithRequestModelPost({
        allowedIPs: "",
        clientUri: values.clientUri,
        pluginType: serviceType,
      });

      return value.token;
    }
    return undefined;
  }, []);

  return (
    <Modal footer={null} open={props.visible} onCancel={() => props.onClose()} title={t("connections.token.addToken")}>
      {createdToken ? (
        <div>
          <Flex align="center" vertical gap="0.5rem" className="tw-mb-4">
            <CheckCircleFilled className="color--success" width={70} />
            <Typography.Title level={5}>{t("connections.token.successfulCreated.successMessage")}</Typography.Title>
          </Flex>
          <Flex gap="1rem" vertical className="background--gray100 tw-p-4">
            <Typography.Text strong>{t("connections.token.successfulCreated.tokenAttention")}</Typography.Text>
            <Flex vertical gap="0.5rem">
              <Typography.Text>{t("connections.token.token")}</Typography.Text>
              <Copy text={createdToken} showIcon isButton>
                {`${createdToken.slice(0, 30)}...`}
              </Copy>
            </Flex>
          </Flex>
        </div>
      ) : (
        <Form form={form} onFinish={handleCreate} layout={"vertical"}>
          <Form.Url
            form={form}
            name={"clientUri"}
            rules={[
              { required: true },
              ({ getFieldValue }) => ({
                validator(): Promise<void> {
                  const url = getFieldValue("clientUri");
                  return url && !ValidUrl(url) ? Promise.reject(t("error.url")) : Promise.resolve();
                },
              }),
            ]}
            label={t("url")}
            placeholder={"www.payping.ir"}
          />
          <OtpCode form={form} onVerify={(isVerified) => setIsOtpValid(isVerified)} />
          <Space className="justify-end">
            <Button onClick={() => props.onClose()} disabled={loading}>
              {t("back")}
            </Button>
            <Button htmlType="submit" type="primary" loading={loading} disabled={!isOtpValid}>
              {t("connections.token.addToken")}
            </Button>
          </Space>
        </Form>
      )}
    </Modal>
  );
};

export default GetTokenModal;
